import { render, staticRenderFns } from "./SettingsDefault.vue?vue&type=template&id=82bb9430&scoped=true"
import script from "./SettingsDefault.vue?vue&type=script&lang=js"
export * from "./SettingsDefault.vue?vue&type=script&lang=js"
import style0 from "./SettingsDefault.vue?vue&type=style&index=0&id=82bb9430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bb9430",
  null
  
)

export default component.exports